export const SET_DEVELOPER_KEY_POPUP = 'SET_DEVELOPER_KEY_POPUP';

export const set_developer_key_popup = (value) => ({
    type: SET_DEVELOPER_KEY_POPUP,
    payload: value
})